// Get all table elements
// Create wrapper container

import $ from 'jquery';

$('.main table').wrap('<div class="table-container"/>');
